
import glob from 'glob';
import { log } from '@bb-cli/base';
import { normaliseExclude } from './excludes';

export default (inDir, excludes) =>
  new Promise((resolve, reject) => {
    const pattern = `${inDir}/**/model.xml`;
    const options = {
      realpath: true,
      ignore: excludes.map(d => normaliseExclude(inDir, d)),
    };
    log.silly('FIND', `glob for ${pattern} with`, options);
    glob(pattern, options, (err, files) =>
      ((err) ? reject(err) : resolve(files))
    );
  });
